<template>
  <nav class="navbar navbar-default">
    <div class="navbar-inner">
      <ul class="nav navbar-nav">
        <li>
          <a id="editor-arrow" @click="toggleEditor"
            ><span class="glyphicon glyphicon-arrow-left" />
            {{ $t('editor.toolbar_title') }}</a
          >
        </li>

        <li>
          <a>{{ $t('editor.current_template') }}: {{ name }}</a>
        </li>
      </ul>
      <div class="navbar-right">
        <button
          id="export-button"
          class="btn btn-primary"
          @click="exportTemplate()"
        >
          {{ $t('editor.save_button') }}
        </button>
        <button
          v-if="!hideButton"
          id="use-button"
          class="btn btn-primary"
          @click="setShowUseModal(true)"
        >
          {{ $t('editor.use_button') }}
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
  name: 'EditorToolbar',
  components: {},
  computed: {
    ...mapState({
      templateName: state => state.templateName,
      hideUseButton: state => state.hideUseButton
    }),
    hideButton: function () {
      return this.hideUseButton === 'true';
    },
    name: function () {
      if (this.templateName === undefined || this.templateName === '') {
        return '--';
      }
      return this.templateName;
    }
  },
  methods: {
    ...mapActions(['exportTemplate']),
    ...mapMutations(['toggleEditor', 'setShowUseModal'])
  }
};
</script>

<style scoped>
#export-button {
  margin-top: 8px;
  margin-right: 2px;
}
#use-button {
  margin-top: 8px;
}
#editor-arrow {
  cursor: pointer;
}
.navbar-default .navbar-nav > li > a:hover {
  color: #777;
}
#editor-arrow:hover {
  color: #333;
}

.navbar {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top-color: #f8f8f8;
}

.navbar-right {
  margin-right: 15px;
}
</style>
